"use client";

import { SegmentedControl } from "@forestsync/ui";
import { useTranslations } from "next-intl";
import { useUiMode } from "./UiModeProvider";
import type { UiMode } from "@forestsync/db";

export function UiModeToggle() {
  const { mode, setMode } = useUiMode();
  const t = useTranslations("nav");

  return (
    <SegmentedControl
      size="xs"
      value={mode}
      onChange={(val) => setMode(val as UiMode)}
      data={[
        { label: t("modeStandard"), value: "standard" },
        { label: t("modeTrader"), value: "trader" },
      ]}
    />
  )
}
